import getFlattenedFiles from '@picsart/cloud-storage/api/getFlattenedFiles';
import { FilesFiltersValues } from '@picsart/cloud-storage/core/enums/files';
import type { IFile } from '@picsart/cloud-storage/types/core/types/files/file';

import { ErrorMessages } from '@/consts/errors';
import { MediaType } from '@/types';
import type { CreationsMediaType } from '@/types';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

// Drive calls images `PHOTO`.
const DRIVE_FILTER_BY_MEDIA_TYPE: Record<
  CreationsMediaType,
  FilesFiltersValues
> = {
  [MediaType.IMAGE]: FilesFiltersValues.Photo,
  [MediaType.VIDEO]: FilesFiltersValues.Video,
  [MediaType.AUDIO]: FilesFiltersValues.Audio,
};

type Params = {
  toolId: string;
  limit?: number;
  offset?: number;
  /** Only files of this type, filtered by Drive. Omitted: every type. */
  mediaType?: CreationsMediaType;
};

type GetDriveFilesResult = {
  files: IFile[];
  hasMore: boolean;
};

const getDriveFiles = async ({
  toolId,
  limit = 30,
  offset = 0,
  mediaType,
}: Params): Promise<GetDriveFilesResult | null> => {
  const result = await withCloudStorageErrorHandling({
    operation: () =>
      getFlattenedFiles({
        headers: getCloudStorageHeaders(),
        params: { limit: String(limit), offset: String(offset) },
        attributes: { tool: toolId },
        ...(mediaType && { filters: [DRIVE_FILTER_BY_MEDIA_TYPE[mediaType]] }),
      }),
    errorMessage: ErrorMessages.loadDriveFiles,
  });

  if (!result) return null;

  const files = (result.response ?? []) as IFile[];
  return { files, hasMore: files.length === limit };
};

export type { GetDriveFilesResult };

export default getDriveFiles;
